module.exports = __webpack_public_path__ + "static/media/CC-3.d438d975.PNG";